import React, { useContext, useEffect, useState } from 'react'
import * as api from '@/apis/aipass'
import { Dayjs } from 'dayjs'
import { SearchReservationEachRoom } from '@/models/reservation'
import { LoaderContextCreator } from '@/contexts/loader'
import { ReservationRoomSelectorModal } from '@/components/molecules/reservation-room-selector-modal'

interface Props {
  usageDay: Dayjs
  onCancel: () => void
  onSubmit: (reservation: SearchReservationEachRoom) => void
}
export const SpaceSearchReservationModal: React.FC<Props> = props => {
  const { setIsLoading } = useContext(LoaderContextCreator())
  const [searchReservations, setSearchReservations] = useState<SearchReservationEachRoom[]>([])

  const doSearch = async () => {
    setIsLoading(true)
    const reservations = await api.getLinkedReservationsBySpace({
      usageDay: props.usageDay.format('YYYY-MM-DD'),
    })
    setSearchReservations(reservations)
    setIsLoading(false)
  }

  useEffect(() => {
    doSearch()
  }, [])

  return <ReservationRoomSelectorModal reservations={searchReservations} onCancel={props.onCancel} onSubmit={props.onSubmit} />
}
